import { Breakpoint, useNotifications, useRouter } from "@relode/core";
import * as React from "react";
import { Route, Switch } from "react-router";

import { CandidatesProvider } from "../_infra/search/candidatesProvider";
import { CandidateSearchProvider } from "../_infra/search/candidateSearchProvider";
import { CandidateContainer } from "../details/candidateContainer";
import { CandidateSearchDesktop } from "./candidatesSearchDesktop";
import { CandidateSearchMobile } from "./candidatesSearchMobile";

export const CandidatesContainer = () => (
    <CandidatesProvider>
        <Switch>
            <Route
                path="/candidates"
                exact
                render={() => (
                    <CandidateSearchProvider>
                        <Breakpoint desktop>
                            <CandidateSearchDesktop />
                        </Breakpoint>
                        <Breakpoint mobile>
                            <CandidateSearchMobile />
                        </Breakpoint>
                    </CandidateSearchProvider>
                )}
            />
            <Route
                path="/candidates/:userIdAndJobId/:jobId"
                exact
                component={CandidateContainer}
            />
            <Route component={CandidatesNotFound} />
        </Switch>
    </CandidatesProvider>
);

const CandidatesNotFound = () => {
    const { actions: notifications } = useNotifications();
    const { history } = useRouter();
    React.useEffect(() => {
        notifications.showModal(
            "warning",
            "candidate not found",
            "We could not find the candidate you were looking for.  Please choose one from the following list.",
            {
                callback: () => {
                    history.replace("/candidates");
                },
                autoClose: true,
                autoCloseDuration: 10000,
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};
